import styled from "styled-components";
import { colors } from "@pepdirect/v3/styles/variables";
import { Button } from "@pepdirect/v3/ui/Button";

export const StyledBreadcrumbsWrapper = styled.div`
  background-color: ${colors.gray200};
  width: 100%;
  height: 36px;
`;

export const StyledBreadcrumbsScroller = styled.div`
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  height: 36px;
  display: flex;
  overflow-x: auto;
`;

export const StyledCrumbAndCaret = styled.div`
  display: flex;
  align-items: center;
  &:first-child {
    padding-left: 17px;
  }

  &:last-child {
    padding-right: 17px;
  }
  svg {
    margin: 0 17px;
  }
`;

export const StyledCrumb = styled(Button)<{
  isCurrent?: boolean;
  disabled?: boolean;
}>`
  text-decoration: none;
  font-size: 13px;
  font-weight: ${({ isCurrent }) => (isCurrent ? 700 : 400)};
  color: ${colors.gray700};
  cursor: ${({ disabled, isCurrent }) => {
    if (isCurrent) return "auto";
    if (disabled) return "not-allowed";
    return "pointer";
  }};
`;
